// extracted by mini-css-extract-plugin
module.exports = {"date":"Versions-module__date___3M8Zw"};